<template>
    <section>
        <gh-stick-navigator>
            <gh-header :hide-register="hideRegister"/>
        </gh-stick-navigator>

        <div class="gh-summit-section ghBanner">
            <div class="container">
                <div class="gh-banner-text">
                    <el-row :gutter="20">
                        <el-col :xs="24" :sm="24" :md="14" :lg="15" :xl="14" :class="ghBannerText">
                            <div class="text-wrapper">
                                <p class="gh-blue gh-bold gh-heading">Join the UK’s largest online suicide prevention conference for mental health professionals.</p>
                                <p class="gh-blue gh-heading gh-bold gh-free">It’s entirely free.</p>
                                <el-button class="mobile-only-register-button gh-button-register gh-bg-red" @click="scrollToSection('registration')">
                                    REGISTER NOW
                                </el-button>

                                <ul class="v-list gh-lightPink">
                                    <li v-for="(benefit, index) in $options.benefits" :key="index" class="v-list__item">
                                        <img width="21" :src="'/images/suicidePreventionSummit/' + benefit.img" alt="">
                                        <span class="v-list__text" v-html="benefit.text"></span>
                                    </li>
                                </ul>
                            </div>
                        </el-col>
                    </el-row>
                </div>
            </div>
        </div> <!-- Banner -->
    </section>
</template>
<script>
    import ghHeader from '@/modules/events/suicidePreventionSummit/components/TheHeader'
    import UX from '@/utils/ux';
    export default {
        components: {
            ghHeader,
            ghStickNavigator: () => import('@/modules/navigator/components/NavigatorStick.vue')
        },
      props: {
        hideRegister: {
          type: Boolean,
          default: false
        }
      },
        methods: {
            scrollToRegistrationForm() {
                UX.scrollTo(document.getElementById('js-registration'));
            },
            scrollToSection(section) {
                const element = document.getElementById(section);
                element && UX.scrollTo(element);
                this.$emit('clicked');
            }
        },
        computed: {
            device() {
                return this.$store.getters['ui/getDevice'];
            },
            ghBannerText() {
                return
            },
          supportedViewport() {
            const suported = ['tablet', 'tablet-portrait', 'tablet-landscaping', 'desktop', 'widescreen'];

            return suported.indexOf(this.$store.state.ui.device) > -1;
          }
        },

        benefits: [
            {
                img: 'join-icon.svg',
                text: 'Join over 20,000 mental health professionals'
            },
            {
                img: 'learn-icon.svg',
                text: 'Learn the latest research in suicide prevention'
            },
            {
                img: 'connect-icon.svg',
                text: 'Connect with leading mental health experts'
            },
            {
                img: 'attend-icon.svg',
                text: 'Attend sessions in real time and on-demand'
            }
        ]
    }
</script>

<style scoped lang="scss">
    @media only screen and (min-width: 1366px) {
        .container {
            width: 88rem;
        }
    }

    .v-list {
      margin-top: 0;
    }

    .gh-free {
        margin: 2rem 0 1rem;
        border-bottom: #84CEEB 5px solid;
        display: inline-block;
    }

    .gh-blue {
        color: #374785;;
    }

    .gh-lightPink {
        color: #F76C6C !important;
    }

    ul {
        border-radius: 5px;
        padding: 1.5rem 0;
        width: fit-content;
        margin-top: 2rem;
        margin-bottom: 6rem;
        font-family: proxima-nova,sans-serif;

        li {
            font-size: 20px;
            font-weight: bold;
            display: flex;
            flex-flow: row nowrap;
            align-items: center;

            span {
                text-align: left;
            }

            img {
                width: 21px;
                margin-right: 1rem;
            }

            + li {
                margin-top: .5rem;
            }
        }
    }

    .ghBanner{
        display: flex;
        align-items: center;
        background-size: contain;
        background-position: center;
        background: url("/images/suicidePreventionSummit/sps-banner-image-2022.jpg");
        @media (min-width: 768px){
            background-position: 73% 10%;
            background-size: cover;
        }
        @media (min-width: 1024px){
            background-position: 99% 10%;
        }
        @media (min-width: 1200px) {
            height: 620px;
        }

        @media (min-width: 1280px) {
            height: 620px;
        }

        @media (min-width: 1366px){
            background-size: cover;
             .gh-banner-text {
                margin-left: 4rem;
            }
        }
        @media (min-width: 1400px){
            background-position: center;
            .gh-banner-text {
                margin-left: 4rem;
            }
        }
         @media (min-width: 1600px){
            .gh-banner-text {
                margin-left: 4rem;
            }
        }
        @media (min-width: 1700px){
            .gh-banner-text {
                margin: 0rem;
                margin-top: 7rem;
            }
        }
        .gh-heading {
            max-width: 645px;
            line-height: 1;
            font-size: 2.2rem;
            font-family: proxima-nova,sans-serif;
            @media (min-width: 1024px) {
                font-size: 2.4rem;
            }
            @media (min-width: 1200px) {
                font-size: 2.88rem;
            }
            @media (min-width: 1366px) {
                font-size: 3rem;
            }
        }

        button.gh-banner-button {
            color: white;
            font-size: 1.2rem;
            background-color: #24c6dc;
            padding: 10px 20px;
            cursor: pointer;
            &:hover {
                background-color: #33b4c5 !important;
            }
        }

        .sub-heading {
            margin-top:40px;
            width:69%;

            @media only screen
            and (min-device-width : 768px)
            and (max-device-width : 1024px)
            and (orientation : portrait) {
                width:55%;
            }

            /* Retina iPad in portrait */
            @media only screen
            and (min-device-width : 768px)
            and (max-device-width : 1024px)
            and (orientation : portrait)
            and (-webkit-min-device-pixel-ratio: 2) {
                width:60%;
            }

        }

        .mobile-only-register-button {
            margin-top:20px;

            @media screen and (min-width: 768px) {
                display: none;
            }
        }

        @media screen and (max-width: 767px) {
            .mobile-hide {
                display: none;
            }
        }

        @media screen and (min-width: 768px) {
            .mobile-show {
                display: none;
            }
        }

        .text-wrapper {
            text-align: center;
            .xs-text {
                font-size: 1.1rem;
            }
            .sm-text {
                font-size: 0.8rem;
                font-weight: 600;
                letter-spacing: 2px;
                @media (min-width: 768px) {
                    font-size: .8rem;
                }
            }

            .lg-text {
                font-size: 2.2rem;
                line-height: 1;
            }
            @media screen and (max-width: 767px) {
                .gh-banner-action {
                    display: flex;
                    align-items: center;
                    justify-content: center;
                }

            }
            @media (min-width: 768px) {
                text-align: left;
                .gh-banner-date {
                    font-size: 1.5rem;
                }
            }
            @media (min-width: 1024px) {
                .sub-heading {
                    width: 90%;
                }
                .xs-text {
                    font-size: 1.1rem;
                }
                .sm-text {
                    font-size: 1.2rem;
                }

                .lg-text {
                    font-size: 2.4rem;
                    line-height: 1;
                }
            }
            @media (min-width: 1366px) {
                .sub-heading {
                    width: 69%;
                }
                .xs-text {
                    font-size: 1.1rem;
                }
                .sm-text {
                    font-size: 1.2rem;
                }

                .lg-text {
                    font-size: 3.6rem;
                    line-height: 1.1;
                    border-width: 7px;
                }
            }
            .gh-date {
                border-top: 4px solid #24c6dc;
                border-bottom: 4px solid #24c6dc;
            }
        }
    }

    @media (max-width: 1199px) {
        .gh-summit-section {
            padding: 4rem 2rem;
        }
    }
    @media (max-width: 767px) {
        .gh-summit-section {
            padding: 3rem 1rem 2rem 1rem;
        }

        ul {
            margin-top: 1rem;
        }
    }

    @media (max-width: 767px) {
        ul {
            li {
                align-items: baseline;
            }
        }
    }

    @media (max-width: 480px) {
      ul {
        margin-bottom: 0;
      }
    }
</style>
